import "../AdvancedLoyaltyEditCreative/advancedLoyaltyEditCreative.scss";

import { useState } from "react";
import pluralize from "pluralize";
import { useSelector } from "react-redux";
import { ProgressBar } from "react-bootstrap";
import Typography from "../../../../../../../common/Typography";
import ExcludeItemsTerms from "../../ExcludeItems/ExcludeItemsTerms";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { formatNumber } from "../../../../../../../../utils/constants/constants";

import {
  getExcludeItemTermText,
  getExcludePaymentTermText,
} from "../../../utils";
import Gift01 from "../../../../../../../assets/Gift01";
import Lock01 from "../../../../../../../assets/Lock01";
import Unlocked01 from "../../../../../../../assets/Unlocked01";
import ShoppingCart from "../../../../../../../assets/ShoppingCart";
import CheckVerified03 from "../../../../../../../assets/CheckVerified03";
import ExcludePaymentTerms from "../../ExcludePaymentMethod/ExcludePaymentTerms";

const AdvancedLoyaltyFinalCreative = (props) => {
  const user = useSelector((state) => state?.auth?.user);
  const initData = useSelector((state) => state?.shortLink?.initData);
  const storeDets = useSelector((state) => state.store.businessDetails);
  const appLoyaltyData = useSelector((state) => state.loyalty?.loyaltyData); // for the protected routes in app

  const [isExcludeItemCollapse, toggleExcludeItemCollapse] = useState(
    props?.isCollapsedItemsTerm || false
  );

  const [isExcludePaymentCollapse, toggleExcludePaymentCollapse] = useState(
    props?.isCollapsedPaymentsTerm || false
  );

  const isDownloadCreative = props?.isDownloadCreative || false;
  const isShortlink = props?.isShortlink;
  const previewTiers = props?.previewTiers; // * this will only come on loyalty/edit/review/{{storeId}} page
  const shortlinkStoreName = props?.storeName;
  const shortlinkLoyaltyData = props?.loyaltyData;
  const orderValue = props?.pointsObj?.order_value;
  const totalSpent = props?.pointsObj?.lifetime_spent;

  const storeName = isShortlink ? shortlinkStoreName : storeDets?.name;
  const loyaltyData = isShortlink ? shortlinkLoyaltyData : appLoyaltyData;
  const currencyView = isShortlink
    ? initData?.currency
    : user?.country?.currency_view;

  const isExcludePaymentSettingActive =
    loyaltyData?.exclude_payment_types?.is_active;
  const currStoreExcludeItem = loyaltyData?.exclude_items;
  const pointsBranding = loyaltyData?.settings?.points_branding;
  const cashbackType = loyaltyData?.settings?.advanced_cashback?.type;

  const isOrderValue = cashbackType === "order_value";
  const isLifeTimeSpent = cashbackType === "lifetime_spent";
  const isShowLocks = isShortlink && (isLifeTimeSpent ? totalSpent > 0 : false);

  const excludeItemTermText = getExcludeItemTermText(pointsBranding);
  const excludePaymentTermText = getExcludePaymentTermText("cashback");

  const showExcludeItemTerm =
    loyaltyData?.terms?.includes(excludeItemTermText) &&
    currStoreExcludeItem?.is_active;

  const showExcludePaymentTerm =
    loyaltyData?.terms?.includes(excludePaymentTermText) &&
    isExcludePaymentSettingActive;

  const loyaltyTiers =
    previewTiers?.length > 0
      ? previewTiers
      : Array.isArray(loyaltyData?.tiers)
      ? loyaltyData?.tiers
      : [];

  const handleExcludeItemCollapse = (e) => {
    e.stopPropagation();
    toggleExcludeItemCollapse(!isExcludeItemCollapse);
  };

  const handleExcludePaymentCollapse = (e) => {
    e.stopPropagation();
    toggleExcludePaymentCollapse(!isExcludePaymentCollapse);
  };

  // tiers settings
  const isSameDayRedemption =
    loyaltyData?.settings?.earn_redeem_same_day?.active;

  const maxCashbackEarnSettings = loyaltyTiers?.reduce(
    (prevTiers, currTier, i) => {
      if (currTier?.settings?.max_points_earn?.active)
        return [
          ...prevTiers,
          {
            tierName: isLifeTimeSpent ? currTier?.name : `Stage ${i + 1}`,
            value: currTier?.settings?.max_points_earn?.value,
          },
        ];

      return prevTiers;
    },
    []
  );
  const minPurchForEarningCashSettings = loyaltyTiers?.reduce(
    (prevTiers, currTier, i) => {
      if (currTier?.settings?.min_requirements?.bill_amount?.active)
        return [
          ...prevTiers,
          {
            tierName: isLifeTimeSpent ? currTier?.name : `Stage ${i + 1}`,
            value: currTier?.settings?.min_requirements?.bill_amount?.amount,
          },
        ];

      return prevTiers;
    },
    []
  );
  const minPurchToRedeemCashSettings = loyaltyTiers?.reduce(
    (prevTiers, currTier, i) => {
      if (currTier?.settings?.min_bill_for_redemption?.active)
        return [
          ...prevTiers,
          {
            tierName: isLifeTimeSpent ? currTier?.name : `Stage ${i + 1}`,
            value: currTier?.settings?.min_bill_for_redemption?.amount,
          },
        ];

      return prevTiers;
    },
    []
  );
  const earnOnSubtotalSettings = loyaltyTiers?.reduce(
    (prevTiers, currTier, i) => {
      if (currTier?.settings?.earn_points_on?.sub_total)
        return [
          ...prevTiers,
          isLifeTimeSpent ? currTier?.name : `Stage ${i + 1}`,
        ];

      return prevTiers;
    },
    []
  );

  return (
    <div className="advanced-loyalty-final-creative-card">
      <div className="preview-card">
        <div
          className="preview-card-top"
          style={{
            backgroundColor: loyaltyData.colors.theme,
          }}
        >
          <div className="card-theme-step">
            <div className="card-header">
              <TransformWrapper
                disabled={true}
                initialScale={loyaltyData?.banner_position?.scale || 1}
                initialPositionX={loyaltyData?.banner_position?.position_x || 0}
                initialPositionY={loyaltyData?.banner_position?.position_y || 0}
              >
                <TransformComponent>
                  <img
                    alt="banner_image"
                    title="banner image"
                    className="banner_image"
                    src={loyaltyData?.banner}
                  />
                </TransformComponent>
              </TransformWrapper>
            </div>
            <div
              className="card-logo-div"
              style={{
                display: "block",
                backgroundColor: loyaltyData?.colors?.text,
              }}
            >
              {loyaltyData?.logo ? (
                <img
                  width="100px"
                  alt="card-logo"
                  src={loyaltyData?.logo}
                  title="Brand Logo"
                  className="card-logo-image"
                />
              ) : (
                <p
                  style={{
                    color: loyaltyData?.colors?.theme,
                  }}
                  className="card-logo-name"
                >
                  {storeName}
                </p>
              )}
            </div>
          </div>
          <div className="card-content">
            <div className="title-content">
              <Typography
                weight="medium"
                size="display-lg"
                style={{ color: loyaltyData?.colors?.text }}
              >
                {loyaltyData?.title}
              </Typography>
              <Typography
                size="text-sm"
                customClass="loyalty-description"
                style={{ color: loyaltyData?.colors?.text }}
              >
                {loyaltyData?.description}
              </Typography>
            </div>
            <div data-tour="loyalty-edit-reward" className={`tiers-div`}>
              {(Array.isArray(loyaltyData?.tiers) ? loyaltyData?.tiers : [])
                ?.sort((a, b) => a.min_value - b.min_value)
                ?.map((tier, i) => {
                  const tierStatus = isShowLocks
                    ? isLifeTimeSpent
                      ? totalSpent > tier?.max_value
                        ? "completed"
                        : totalSpent >= tier?.min_value &&
                          totalSpent <= tier?.max_value
                        ? "unlocked"
                        : "locked"
                      : isOrderValue
                      ? orderValue > tier?.max_value
                        ? "completed"
                        : orderValue >= tier?.min_value &&
                          orderValue <= tier?.max_value
                        ? "unlocked"
                        : "locked"
                      : null
                    : null;

                  const tierProgress =
                    isShowLocks && isLifeTimeSpent
                      ? getTiersProgress(
                          totalSpent,
                          tier?.min_value,
                          tier?.max_value,
                          tier.max_value === 1000000000000000
                        )
                      : 0;

                  return (
                    <div
                      key={i}
                      className={`tier-row${
                        tierStatus === "locked"
                          ? " inactive-tier-row"
                          : tierStatus === "unlocked"
                          ? " active-tier-row"
                          : tierStatus === "completed"
                          ? " completed-tier-row"
                          : ""
                      }`}
                      style={{
                        gap: isLifeTimeSpent ? "16px" : "10px",
                      }}
                    >
                      {isLifeTimeSpent && (
                        <>
                          <div className="lifetime-spent-tier-info">
                            <div className="tier-info-heading">
                              <div className="left-side">
                                <img
                                  alt="badge"
                                  width="20px"
                                  height="20px"
                                  className="high-voltage"
                                  src="/assets/icons/highVoltage.svg"
                                />
                                <Typography
                                  weight={
                                    cashbackType === "order_value"
                                      ? "medium"
                                      : "semibold"
                                  }
                                  size={
                                    isDownloadCreative
                                      ? "heading-lg"
                                      : "display-md"
                                  }
                                  tag="h2"
                                >
                                  {tier?.name}
                                </Typography>
                              </div>

                              {tierStatus === "locked" ? (
                                <Lock01 />
                              ) : tierStatus === "unlocked" ? (
                                <Unlocked01 />
                              ) : tierStatus === "completed" ? (
                                <CheckVerified03 />
                              ) : (
                                <></>
                              )}
                            </div>
                            <div className="tier-info-desc">
                              <Gift01 size="20px" color="#652583" />
                              <Typography size="text-sm" weight="regular">
                                Earn{" "}
                                <span style={{ fontWeight: 600 }}>
                                  {tier?.points_rule?.value}
                                  {"% "}
                                  {pointsBranding?.active
                                    ? pluralize(
                                        pointsBranding?.name,
                                        loyaltyData?.points_earned
                                      )
                                    : "Cashback"}
                                </span>{" "}
                                on every purchase
                              </Typography>
                            </div>
                          </div>
                          <div className="divider" />
                          {tier.max_value === 1000000000000000 ? (
                            <div className="lifetime-spent-range-div">
                              <div className="min-max-value">
                                <Typography size="text-sm" weight="medium">
                                  {currencyView}
                                  {tier.min_value} and upward
                                </Typography>
                              </div>
                            </div>
                          ) : (
                            <div className="lifetime-spent-range-div">
                              {isDownloadCreative ? (
                                <div className="min-max-value">
                                  <Typography size="text-sm" weight="medium">
                                    {currencyView}
                                    {tier.min_value} - {currencyView}
                                    {tier.max_value} total spent
                                  </Typography>
                                </div>
                              ) : (
                                <div className="min-max-value">
                                  <Typography size="text-sm" weight="medium">
                                    {currencyView}
                                    {tier.min_value}
                                  </Typography>
                                  <Typography size="text-sm" weight="medium">
                                    {currencyView}
                                    {tier.max_value} total spent
                                  </Typography>
                                </div>
                              )}
                              {!isDownloadCreative && (
                                <ProgressBar now={tierProgress || 0} />
                              )}
                            </div>
                          )}
                        </>
                      )}
                      {isOrderValue && (
                        <>
                          <div className="order-value-tier-range">
                            <Typography
                              size={
                                isDownloadCreative ? "heading-lg" : "display-md"
                              }
                              weight="medium"
                              tag="h5"
                            >
                              {currencyView} {tier?.min_value}{" "}
                              {tier.max_value === 1000000000000000
                                ? " and above"
                                : ` - ${currencyView}${tier?.max_value}`}
                            </Typography>
                            <div className="order-value-div">
                              <Typography size="text-sm" weight="medium">
                                Order Value
                              </Typography>
                              <ShoppingCart
                                weight="18px"
                                height="18px"
                                color="#697777"
                              />
                            </div>
                          </div>
                          <div className="order-value-info-desc">
                            <div className="left-side">
                              <Gift01 size="20px" color="#E31B54" />
                              <Typography size="text-sm" weight="regular">
                                Earn{" "}
                                <span style={{ fontWeight: 600 }}>
                                  {tier?.points_rule?.value}%{" "}
                                  {pointsBranding?.active
                                    ? pluralize(
                                        pointsBranding?.name,
                                        tier?.points_rule?.value
                                      )
                                    : "cashback"}
                                </span>{" "}
                                on every purchase
                              </Typography>
                            </div>
                            {tierStatus === "locked" ? (
                              <Lock01 />
                            ) : tierStatus === "unlocked" ? (
                              <Unlocked01 />
                            ) : tierStatus === "completed" ? (
                              <CheckVerified03 />
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="preview-footer">
          <Typography size="text-md" weight="medium" customClass="term-header">
            Terms & Conditions
          </Typography>
          {loyaltyData?.terms?.length > 0 &&
            loyaltyData?.terms?.map((term, i) =>
              term?.length === 0 ||
              term === excludeItemTermText ||
              term === excludePaymentTermText ? (
                <></>
              ) : (
                <Typography key={i} customClass="term">
                  *{term}
                </Typography>
              )
            )}
          {minPurchForEarningCashSettings?.length > 0 && (
            <Typography customClass="term">
              *Minimum purchase required for earning{" "}
              {pointsBranding?.active
                ? pluralize(pointsBranding?.name, 2)
                : "cashback"}
              :{" "}
              <Typography tag="span" weight="medium" customClass="term">
                {minPurchForEarningCashSettings
                  ?.map(
                    (tier) =>
                      `${tier?.tierName} - ${currencyView}${tier?.value}`
                  )
                  ?.join("  •  ")}
              </Typography>
            </Typography>
          )}
          {minPurchToRedeemCashSettings?.length > 0 && (
            <Typography customClass="term">
              *Minimum purchase required for redeeming{" "}
              {pointsBranding?.active
                ? pluralize(pointsBranding?.name, 2)
                : "cashback"}
              :{" "}
              <Typography tag="span" weight="medium" customClass="term">
                {minPurchToRedeemCashSettings
                  ?.map(
                    (tier) =>
                      `${tier?.tierName} - ${currencyView}${tier?.value}`
                  )
                  ?.join("  •  ")}
              </Typography>
            </Typography>
          )}
          {maxCashbackEarnSettings?.length > 0 && (
            <Typography customClass="term">
              *Maximum{" "}
              {pointsBranding?.active
                ? pluralize(pointsBranding?.name, 2)
                : "cashback"}{" "}
              earned on every purchase:{" "}
              <Typography tag="span" weight="medium" customClass="term">
                {maxCashbackEarnSettings
                  ?.map(
                    (tier) =>
                      `${tier?.tierName} - ${
                        pointsBranding?.active ? "" : currencyView
                      }${tier?.value}${
                        pointsBranding?.active
                          ? ` ${pluralize(pointsBranding?.name, tier?.value)}`
                          : ""
                      }`
                  )
                  ?.join("  •  ")}
              </Typography>
            </Typography>
          )}
          {earnOnSubtotalSettings?.length > 0 && (
            <Typography customClass="term">
              *
              {pointsBranding?.active
                ? pluralize(pointsBranding?.name, 2)
                : "Cashback"}{" "}
              will be issued on subtotal amount (before tax & charges) for:{" "}
              <Typography tag="span" weight="medium" customClass="term">
                {earnOnSubtotalSettings?.map((tier) => tier)?.join("  •  ")}
              </Typography>
            </Typography>
          )}
          {isSameDayRedemption && (
            <Typography customClass="term">
              *Loyalty{" "}
              {pointsBranding?.active
                ? pluralize(pointsBranding?.name, 2)
                : "cashback"}{" "}
              cannot be redeemed on the same day as the purchase made.
            </Typography>
          )}
          {showExcludeItemTerm && (
            <ExcludeItemsTerms
              textColor={"#0e1b1b"}
              currStoreExcludeItem={currStoreExcludeItem}
              isExcludeItemCollapse={isExcludeItemCollapse}
              handleExcludeItemCollapse={handleExcludeItemCollapse}
            />
          )}
          {showExcludePaymentTerm && (
            <ExcludePaymentTerms
              loyaltyType="cashback"
              textColor={"#0e1b1b"}
              isExcludePaymentCollapse={isExcludePaymentCollapse}
              handleExcludePaymentCollapse={handleExcludePaymentCollapse}
              excludedPaymentMethods={loyaltyData?.exclude_payment_types?.list}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdvancedLoyaltyFinalCreative;

const getTiersProgress = (value, minVal, maxVal, isLastTierNoLimit) => {
  let tiersProgress = 0;
  const totalRange = formatNumber(maxVal) - formatNumber(minVal);
  const totalFilledTier = formatNumber(value) - formatNumber(minVal);

  if (totalFilledTier > 0) tiersProgress = (totalFilledTier * 100) / totalRange;
  if (isLastTierNoLimit) tiersProgress = 100;

  return formatNumber(tiersProgress);
};
